import request from '../request/request';
import {handleRes} from '../utils/utils';


interface HandleResInterface {
    success: any,
    fail: any,
}


const GETCompany = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.GETCompany(params,);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};


export {
    GETCompany,
};
